import {
  CommunityMemberInviteLink,
  InviteStatus,
  CommunityRole,
  UserStatus,
} from "@bbb/model";
import {
  CommunityTeamMemberStatusUpdatePayload,
  CommunityTeamMemberInvitePayload,
  CommunityTeamMemberInviteResponse,
  CommunityTeamMember,
  CommunityTeamMemberStatusUpdateResponse,
} from "@interfaces";
import { _apiRequest } from "./_apiClients";

//#region INVITE
export function createCommunityInviteLink(
  token: string,
  payload: CommunityMemberInviteLink
) {
  return _apiRequest<{
    inviteId: string;
    token: string;
    status: UserStatus;
    expiresAt: string;
  }>(`/v1/communities/${payload.communityId}/team/invitations/link`, {
    method: "POST",
    token,
    data: payload,
  });
}

export function claimCommunityInviteByToken(
  token: string | undefined,
  payload: { inviteToken: string }
) {
  return _apiRequest<{
    communityId: string;
    role: CommunityRole;
    status: UserStatus;
    claimOutcome: "claimed" | "already_claimed";
  }>("/v1/communities/team/invitations/claim", {
    method: "POST", //TODO Patch
    token,
    data: { token: payload.inviteToken },
  });
}

export function fetchCommunityInvitePreview(inviteToken: string) {
  return _apiRequest<{
    communityId: string;
    communityName: string;
    role: CommunityRole;
    status: InviteStatus;
    method: "link";
    expiresAt: string | null;
    expired: boolean;
  }>(`/v1/communities/team/invitations/${encodeURIComponent(inviteToken)}`, {
    authRequired: false,
  });
}

export function deleteCommunityInvite(
  token: string,
  payload: { communityId: string; inviteId: string }
) {
  const { communityId, inviteId } = payload;
  return _apiRequest<void>(
    `/v1/communities/${communityId}/team/invitations/${inviteId}`,
    {
      method: "DELETE",
      token,
    }
  );
}

//#endregion INVITE

//#region TEAM MEMBER

/**
 * Add a team member to a community.
 * @param token
 * @param communityId
 * @param payload
 * @returns
 */
export function addCommunityMember(
  token: string,
  payload: CommunityTeamMemberInvitePayload
) {
  const { communityId, ...body } = payload;
  return _apiRequest<CommunityTeamMemberInviteResponse>(
    `/v1/communities/${communityId}/team`,
    {
      method: "POST",
      token,
      data: body,
    }
  );
}

/**
 * Get team members of a community.
 * Only accessible to community owner.
 * @param token
 * @param communityId
 * @returns
 */
export function fetchCommunityMemberInfos(token: string, communityId: string) {
  return _apiRequest<CommunityTeamMember[]>(
    `/v1/communities/${communityId}/team`,
    {
      token,
    }
  );
}

export function removeCommunityMember(
  token: string,
  payload: { communityId: string; userId: string }
) {
  const { communityId, userId } = payload;
  return _apiRequest<void>(`/v1/communities/${communityId}/team/${userId}`, {
    method: "DELETE",
    token,
  });
}

/**
 * Update a team member's status or role.
 */
export function updateCommunityMemberStatus(
  token: string,
  payload: CommunityTeamMemberStatusUpdatePayload
) {
  const { communityId, userId, ...body } = payload;
  return _apiRequest<CommunityTeamMemberStatusUpdateResponse>(
    `/v1/communities/${communityId}/team/${userId}/status`,
    {
      method: "PATCH",
      token,
      data: body,
    }
  );
}

//#endregion TEAM MEMBER
